export default __webpack_public_path__ + "static/media/Shield of the Black Pharaoh.0a875fe3.jpg";